import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from '../components.module';
import { PrintEntityPage } from './print-entity';
import { PrintEntityPageRoutingModule } from './print-entity-routing.module';
import { Printer, PrintOptions } from '@awesome-cordova-plugins/printer/ngx';

@NgModule({
  declarations: [PrintEntityPage],
  imports: [IonicModule, CommonModule, ComponentsModule, PrintEntityPageRoutingModule],
  providers: [Printer],
})
export class PrintEntityPageModule {}
